import {
  createFeature,
  createFeatureSelector,
  createReducer,
  createSelector,
  on,
} from '@ngrx/store';
import { PortalRolesActions } from './portal-roles.actions';
import { PortalRole } from './portal-roles.model';

export const portalRolesFeatureKey = 'portalRoles';

export interface PortalRolesState {
  portalRoles: Record<PortalRole['portalRoleId'], PortalRole>;
}

export const initialState: PortalRolesState = {
  portalRoles: {},
};

export const reducer = createReducer(
  initialState,
  on(PortalRolesActions.getPortalRolesSuccess, (state, action) => ({
    ...state,
    portalRoles: Object.fromEntries(
      action.portalRoles.map((role) => [role.portalRoleId, role]),
    ),
  })),
);

export const portalRolesFeatureSelector =
  createFeatureSelector<PortalRolesState>(portalRolesFeatureKey);

export const portalRolesFeature = createFeature({
  name: portalRolesFeatureKey,
  reducer,
  extraSelectors: () => {
    return {
      selectPortalRoles: createSelector(
        portalRolesFeatureSelector,
        (state) => state.portalRoles,
      ),
    };
  },
});

export const { selectPortalRoles } = portalRolesFeature;
